 document.addEventListener('DOMContentLoaded', function() {
    // Get all blog post cards
    const blogPostCards = document.querySelectorAll(".blog-post-card");
    
    // Initialize Article Type Dropdown
    initArticleTypeDropdown();
    
    // Initialize Title/Duration Dropdown
    initTitleDurationDropdown();
    
    // Global click handler to close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.article-type__dropdown-container')) {
            closeDropdown('.article-type__dropdown-container');
        }
        if (!e.target.closest('.title-duration__dropdown-container')) {
            closeDropdown('.title-duration__dropdown-container');
        }
    });
    
    // Global keyboard handler for ESC key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            closeDropdown('.article-type__dropdown-container');
            closeDropdown('.title-duration__dropdown-container');
        }
    });
    
    /**
     * Initialize Article Type Dropdown with dynamic subcategories
     */
    function initArticleTypeDropdown() {
        const container = document.querySelector('.article-type__dropdown-container');
        if (!container) return;
        
        const button = container.querySelector('.dropdown-button');
        const menu = container.querySelector('.dropdown-menu');
        const icon = container.querySelector('.dropdown-icon');
        const selectedText = container.querySelector('#selectedText');
        
        // Extract unique subcategories
        const allSubCategoryTags = document.querySelectorAll(".post-sub-category-container");
        const uniqueSubCatTexts = [...new Set(
            [...allSubCategoryTags]
                .map(tag => tag.textContent.trim())
                .filter(text => text !== '')
        )];
        
        // Clear and populate dropdown menu
        menu.innerHTML = '';
        
        // Add default "All Articles" option
        const defaultItem = createDropdownItem('All Articles', 'all');
        menu.appendChild(defaultItem);
        
        // Add subcategory items
        uniqueSubCatTexts.forEach(text => {
            const slug = text.toLowerCase().replace(/\s+/g, '-');
            const item = createDropdownItem(text, slug);
            menu.appendChild(item);
        });
        
        // Toggle dropdown
        button.addEventListener('click', function(e) {
            e.stopPropagation();
            toggleDropdown(menu, icon);
        });
        
        // Handle item selection
        menu.addEventListener('click', function(e) {
            const item = e.target.closest('.dropdown-item');
            if (!item) return;
            
            selectedText.textContent = item.textContent;
            closeDropdown('.article-type__dropdown-container');
            
            // Filter blog posts
            filterBlogPosts(item.dataset.value);
        });
    }
    
    /**
     * Initialize Title/Duration Dropdown
     */
    function initTitleDurationDropdown() {
        const container = document.querySelector('.title-duration__dropdown-container');
        if (!container) return;
        
        const button = container.querySelector('.dropdown-button');
        const menu = container.querySelector('.dropdown-menu');
        const icon = container.querySelector('.dropdown-icon');
        const selectedText = container.querySelector('#selectedText');
        
        // Toggle dropdown
        button.addEventListener('click', function(e) {
            e.stopPropagation();
            toggleDropdown(menu, icon);
        });
        
        // Handle item selection
        menu.addEventListener('click', function(e) {
            const item = e.target.closest('.dropdown-item');
            if (!item) return;
            
            selectedText.textContent = item.textContent;
            closeDropdown('.title-duration__dropdown-container');
            
            // Sort blog posts based on selection
            sortBlogPosts(item.textContent);
        });
    }
    
    /**
     * Create a dropdown item element
     */
    function createDropdownItem(text, value) {
        const item = document.createElement('div');
        item.className = 'dropdown-item';
        item.dataset.value = value;
        item.textContent = text;
        return item;
    }
    
    /**
     * Toggle dropdown open/close state
     */
    function toggleDropdown(menu, icon) {
        menu.classList.toggle('open');
        icon.classList.toggle('open');
    }
    
    /**
     * Close a specific dropdown
     */
    function closeDropdown(containerSelector) {
        const container = document.querySelector(containerSelector);
        if (!container) return;
        
        const menu = container.querySelector('.dropdown-menu');
        const icon = container.querySelector('.dropdown-icon');
        
        if (menu) menu.classList.remove('open');
        if (icon) icon.classList.remove('open');
    }
    
    /**
     * Filter blog posts by category
     */
    function filterBlogPosts(value) {
        const slug = value.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');
        
        blogPostCards.forEach(card => {
            if (slug === 'all') {
                card.style.display = 'block';
            } else {
                const blogPost = card.querySelector(".blog-post");
                if (blogPost && blogPost.classList.contains(slug)) {
                    card.style.display = 'block';
                } else {
                    card.style.display = 'none';
                }
            }
        });
    }
    
    /**
     * Sort blog posts based on selected option
     */
    function sortBlogPosts(sortType) {
        const container = document.querySelector('.blog-posts-container') || blogPostCards[0]?.parentElement;
        if (!container) return;
        
        const cardsArray = Array.from(blogPostCards);
        
        cardsArray.sort((a, b) => {
            if (sortType === 'Newest') {
                // Assuming cards have a data-date attribute or are already in newest order
                const dateA = new Date(a.dataset.date || 0);
                const dateB = new Date(b.dataset.date || 0);
                return dateB - dateA;
            } else if (sortType === 'Title: A - Z') {
                const titleA = a.querySelector('.blog-post-title')?.textContent.trim().toLowerCase() || '';
                const titleB = b.querySelector('.blog-post-title')?.textContent.trim().toLowerCase() || '';
                return titleA.localeCompare(titleB);
            } else if (sortType === 'Title: Z - A') {
                const titleA = a.querySelector('.blog-post-title')?.textContent.trim().toLowerCase() || '';
                const titleB = b.querySelector('.blog-post-title')?.textContent.trim().toLowerCase() || '';
                return titleB.localeCompare(titleA);
            }
            return 0;
        });
        
        // Re-append cards in sorted order
        cardsArray.forEach(card => container.appendChild(card));
    }
});